<script>
import Layout from "../../../router/layouts/print";
import appConfig from "@/app.config";
// import { saleService } from "../../../services/saleservice/sale.service";


/* eslint-disable no-console */
export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      title: "Payment Detail",
      items: [
        {
          text: "Schedule",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      saledetail: null,
      saleschedule: null,
      registerDates: [],
      loan: null,
      loanDuration: 0,
      
    };
  },
  mounted() {

    this.saledetail = this.saleDetail;
    this.registerDates = this.saleDetail ? this.saleDetail.register_date_show.split('-') : [];
    this.saleschedule = this.saleSchedule;
    this.loan = this.loans;
    this.loanDuration = this.duration;

  },

  watch: {

    saleDetail: {
      immediate: true, 
      handler (val) {
        this.saledetail = val;
        this.registerDates = val ? val.register_date_show.split('-') : [];
      }
    },
    saleSchedule: {
      immediate: true, 
      handler (val) {
        this.saleschedule = val;
      }
    },
    loans: {
      immediate: true, 
      handler (val) {
        this.loan = val;
      }
    },
    duration: {
      immediate: true, 
      handler (val) {
        this.loanDuration = val;
      }
    }
  },

  methods: {

    formatCurrency(value, sign = '$') {

      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },

    getDay(date) {
      const weekday = ["អាទិត្យ", "ច័ន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"];
      let d = new Date(date);
      
      return weekday[d.getDay()];
      // console.log(date);
      // return '';
    }
  },

  props: {

    saleDetail: null,
    saleSchedule: null,
    loans: null,
    duration: {
      type: Number,
      default: 0
    }
  }
};

</script>

<template>
  <Layout>
        <center>
          <div class="col dblack box-a4-long">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="14%"><p>&nbsp;</p></td>
                <td width="86%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khm h6">លំនៅឋាន អេចស៊ី ឯ.ក</p>
                  <p class="enb h6">LOMNOV THAN HC CO., LTD</p>
                  <p class="khs h7">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h7">ទូរស័ព្ទលេខៈ 078 554 077 | 015 554 077 Email: account@h-residence.net</p>
                </td>
              </tr>
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <br/>
            <table width="100%" class="content-general"><tr><td class="center">
              <p class="h5 khm">កាលវិភាគបង់ប្រាក់</p>
              <p class="h5 enb">PAYMENT SCHEDULE</p>
              <p class="">
                <img src="@/assets/images/bellow01.png" style="width: 130px;"/>
              </p>
            </td></tr></table>
            <br>

            <table class="content-general h8 detail-table left" width="100%">
              
              <tr>
                <td style="width:3cm"><p class="khs">លេខកូដយូនីត</p></td>
                <td style="width:2.8cm"><p class="khs"><b>: {{saledetail && saledetail.property_code}} ជាន់ទី: {{saledetail && (saledetail.property_floor + '').padStart(2, '0')}}</b></p></td>
                <td style="width:3cm"><p class="khs">គម្រោង</p></td>
                <td style="width:4.2cm"><p class="khs"><b>: {{saledetail && saledetail.project_name}}</b></p></td>
                <td style="width:2.2cm"><p class="khs">អ្នកលក់</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.seller_name}}</b></p></td>
              </tr>
              <tr>
                <td><p class="khs">តម្លៃយូនីត</p></td>
                <td><p class="khs"><b>: {{saledetail && formatCurrency(saledetail.amount, '')}} USD</b></p></td>
                <td><p class="khs">ប្រភេទកិច្ចសន្យា</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.contract_type}}</b></p></td>
                <td><p class="khs">លេខកូដកម្ចី</p></td>
                <td><p class="khs"><b>: {{loan ? saledetail && saledetail.loan_code : ''}}</b></p></td>
              </tr>
              <tr>
                <td><p class="khs">បញ្ចុះតម្លៃ</p></td>
                <td><p class="khs"><b>: {{saledetail && formatCurrency(saledetail.discount, '')}} USD</b></p></td>
                <td><p class="khs">លេខកូដអតិថិជន</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.customer_code}}</b></p></td>
                <td><p class="khs">កាលបរិច្ឆេទកម្ចី</p></td>
                <td><p class="khs"><b>: {{loan && loan.pay_date_show}}</b></p></td>
              </tr>
              <tr>
                <td><p class="khs">តម្លៃលក់</p></td>
                <td><p class="khs"><b>: {{saledetail && formatCurrency(saledetail.sale_price, '')}} USD</b></p></td>
                <td><p class="khs">ឈ្មោះអតិថិជន</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.customer_name}}</b></p></td>
                <td><p class="khs">ចំនួនប្រាក់កម្ចី</p></td>
                <td><p class="khs"><b>: {{loan && formatCurrency(loan.principal_pay + loan.balance)}} USD</b></p></td>
              </tr>
              <tr>
                <td><p class="khs">ប្រាក់កក់/បង់ដើម</p></td>
                <td><p class="khs"><b>: {{saledetail && formatCurrency(saledetail.deposit, '')}} USD</b></p></td>
                <td><p class="khs">ឈ្មោះគូភាគី</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.partner_name}}</b></p></td>
                <td><p class="khs">អត្រាការប្រាក់</p></td>
                <td><p class="khs"><b>: {{loan ? '1%' : '0%'}}/ខែ</b></p></td>
              </tr>
              <tr>
                <td><p class="khs">ប្រាក់ដើមបានបង់សរុប</p></td>
                <td><p class="khs"><b>: {{saledetail && formatCurrency(saledetail.principle_pay, '')}} USD</b></p></td>
                <td><p class="khs">លេខទូរស័ព្ទអតិថិជន</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.customer_phone}}</b></p></td>
                <td><p class="khs">រយៈពេលកម្ចី</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.loanDuration}} ខែ</b></p></td>
              </tr>
              <tr>
                <td><p class="khs">ប្រាក់ដើមនៅសល់សរុប</p></td>
                <td><p class="khs"><b>: {{saledetail && formatCurrency(saledetail.principle_pending)}} USD</b></p></td>
                <td><p class="khs">អត្តសញ្ញាណប័ណ្ណលេខ</p></td>
                <td><p class="khs"><b>: {{saledetail && saledetail.id_no}}</b></p></td>
                <td><p class="khs">ប្រាក់បង់ប្រចាំខែ</p></td>
                <td><p class="khs"><b>: {{loan && formatCurrency(loan.integer_pay, '')}} USD</b></p></td>
              </tr>
            </table>
            <div style="height: 5px;"></div>
            <table style="width:100%">
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <div style="height: 5px;"></div>
            <table class="content-general h8 schedule-table" width="100%">
              <thead>
                <tr>
                  <td><p class="khs">ល.រ</p></td>
                  <td colspan="2"><p class="khs">កាលបរិច្ឆេទបង់ប្រាក់</p></td>
                  <td><p class="khs">ប្រាក់បង់ប្រចាំខែ</p></td>
                  <td><p class="khs">ប្រាក់ដើម</p></td>
                  <td><p class="khs">ការប្រាក់</p></td>
                  <td><p class="khs">សមតុល្យប្រាក់ដើម</p></td>
                  <td><p class="khs">ថ្ងៃបង់ជាក់ស្តែង</p></td>
                  <td><p class="khs"> កំណត់ចំណាំ </p></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(list, index) in saleschedule" :key="list.id">
                  <td><p class="khs">{{index+1}}</p></td>
                  <td><p class="khs">{{`${list.pay_date_show}`}}</p></td>
                  <td><p class="khs" style="font-size: 7pt;">{{list.day_show}}</p></td>
                  <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.integer_pay)}}</p></td>
                  <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.principal_pay)}}</p></td>
                  <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.interest)}}</p></td>
                  <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.balance)}}</p></td>
                  <td><p class="khs" style="text-align: center;" v-for="date_list in list.pay_list" :key="date_list.id">{{date_list.pay_date}}</p></td>
                  <td v-if="list.schedule_status_id == 3" style="text-align:center; font-size: 17pt; line-height: 40%; color: #656569;"><span>&#x2611;</span></td>
                  <td v-else style="text-align:center; font-size: 25pt; line-height: 40%; color: #656569;"><span>&squ;</span></td>
                </tr>
                <tr>
                  <td colspan="3"><p class="khs" style="font-size: 11pt;">សរុប</p></td>
                  <td><p class="khs" style="font-size: 11pt; text-align: right; padding-right: 10px">{{saleschedule && formatCurrency(saleschedule.reduce((sum, item) => sum + item.integer_pay, 0))}}</p></td>
                  <td><p class="khs" style="font-size: 11pt; text-align: right; padding-right: 10px">{{saleschedule && formatCurrency(saleschedule.reduce((sum, item) => sum + item.principal_pay, 0))}}</p></td>
                  <td><p class="khs" style="font-size: 11pt; text-align: right; padding-right: 10px">{{saleschedule && formatCurrency(saleschedule.reduce((sum, item) => sum + item.interest, 0))}}</p></td>
                  <td colspan="3"><p class="khs"></p></td>
                  
                </tr>
              </tbody>
            </table>
            <br>
            <table width="100%" class="center">
              <tr><td colspan="3" class="right"><p class="khs">ថ្ងៃទី {{registerDates[0]}} ខែ {{registerDates[1]}} ឆ្នាំ {{registerDates[2]}} </p></td></tr>
              <tr>
                <td><p class="khm">ស្នាមមេដៃ ភាគី “ខ”</p></td>
                <td><p class="khm">ស្នាមមេដៃគូភាគី ភាគី “ខ”</p></td>
                <td><p class="khm">ស្នាមមេដៃភាគី “ក”</p></td>
              </tr>
              <tr>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center" class="khm">{{saledetail && saledetail.customer_name}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center" class="khm">{{saledetail && saledetail.partner_name}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p class="khm">លឹម ទ្រី</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>